import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import "./styles/tokens.css";
import App from "./App";
import "../node_modules/font-awesome/css/font-awesome.min.css";

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

// Der statische Crawler-Fallback aus index.html hat seinen Zweck erfüllt.
// Er ist per CSS schon unsichtbar; entfernen hält die gerenderte Seite sauber
// (sonst stünde dort eine zweite H1) und spart einem Screenreader den Ballast.
document.getElementById("static-fallback")?.remove();
